import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const needsOnboarding = (u) => u && u.role !== "admin" && !u.onboarding_completed_at;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const handleAuth = (data) => {
    setUser(data.user);
    return data;
  };

  const login = async (email, password, remember = false) => handleAuth((await api.post("/auth/login", { email, password, remember })).data);
  const register = async (payload) => handleAuth((await api.post("/auth/register", payload)).data);
  const refreshUser = useCallback(async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  }, []);
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
